import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // localStorage
import AuthSlice from "./Auth/AuthSlice";
import MerchantSlice from "./Merchant/MerchantSlice";
import DealsSlice from "./Deals/DealsSlice";
import InfluencerSlice from "./Influencer/InfluencerSlice";
import CollaborationSlice from "./Collaboration/CollaborationSlice";
import CommissionSlice from "./Commission/CommissionSlice";
import notificationsReducer from "./Notification/NotificationsSlice";
import InfluencerDealProposalSlice from "./InfluencerDealProposal/InfluencerDealProposalSlice";
import OrderSlice from "./Order/OrderSlice";
import configurationSlice from "./configuration/configurationSlice";
import KYCSlice from "./KYC/KycSlice";
import ReportsSlice from "./Reports/ReportSlice";
import DashboardSlice from "./Dashboard/DashboardSlice";

// Redux Persist configuration for auth
const authPersistConfig = {
  key: "sumoEatsMerchantAuth",
  storage,
  whitelist: ["loggedInUser"], // Keep active session role/user across refresh
};


// Redux Persist configuration for merchant
const merchantPersistConfig = {
  key: "sumoEatsMerchant",
  storage,
  whitelist: ["merchantProfile"], // Persist merchant profile only, not allMerchants
  blacklist: ["allMerchants", "selectedMerchantId"], // Don't persist these (clear on refresh)
};

// Create persisted reducers
const persistedAuthReducer = persistReducer(authPersistConfig, AuthSlice);
const persistedMerchantReducer = persistReducer(
  merchantPersistConfig,
  MerchantSlice
);

const dashboardPersistConfig = {
  key: "sumoEatsMerchantDashboard",
  storage,
  whitelist: ["filters", "summary"], // Persist filters and summary, not the list
};

const store = configureStore({
  reducer: {
    merchant: persistedMerchantReducer,
    auth: persistedAuthReducer,
    deals: DealsSlice,
    influencer: InfluencerSlice,
    collaboration: CollaborationSlice,
    commission: CommissionSlice,
    notifications: notificationsReducer,
    influencerDealProposal: InfluencerDealProposalSlice,
    order: OrderSlice,
    configuration: configurationSlice,
    kyc: KYCSlice,
    dashboard: persistReducer(dashboardPersistConfig, ReportsSlice),
    earningsDashboard: DashboardSlice,

  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore redux-persist actions for serializable check
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export const persistor = persistStore(store);
export default store;
